import { useEffect } from 'react';
import { useUserHasConfluenceAccess } from '@atlassian/jira-confluence-integration-controls/src/controllers/use-user-has-confluence-access/index.tsx';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { ConfluenceTemplate } from '../../../common/constants.tsx';
import { PLACEHOLDER_TEMPLATE_CO_USE_EXPERIMENT_ID } from './index.tsx';

type CrossFlowEligibilityProps = {
	template: ConfluenceTemplate | null;
	isDismissed: boolean;
	hasActivatedConfluenceWithinFourteenDays: boolean;
};

type CoUseEligibility = {
	isCoUseEligible: boolean;
};

export const useIsCoUseEligible = ({
	template,
	isDismissed,
	hasActivatedConfluenceWithinFourteenDays,
}: CrossFlowEligibilityProps): CoUseEligibility => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { licensedProducts } = useTenantContext();
	const tenantHasConfluence = licensedProducts?.confluence === true;
	const { hasAccess } = useUserHasConfluenceAccess();

	const isCoUseEligible =
		!!template &&
		tenantHasConfluence &&
		hasAccess &&
		!isDismissed &&
		hasActivatedConfluenceWithinFourteenDays;

	useEffect(() => {
		if (!isCoUseEligible) return;
		fireTrackAnalytics(createAnalyticsEvent({}), 'placeholderTemplateCoUse exposed', {
			flagKey: PLACEHOLDER_TEMPLATE_CO_USE_EXPERIMENT_ID,
		});
	}, [createAnalyticsEvent, isCoUseEligible]);

	return {
		isCoUseEligible,
	};
};
